<template>
  <div class="iai-skeleton" :style="{ width, height, borderRadius: radius }"></div>
</template>

<script setup lang="ts">
defineProps({
  width: { type: String, default: "48px" },
  height: { type: String, default: "8px" },
  radius: { type: String, default: "200px" },
});
</script>

<style lang="scss" scoped>
.iai-skeleton {
  height: 1rem;
  position: relative;
  overflow: hidden;
  background-color: var(--color-bg-secondary);

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, transparent 0%, var(--color-bg-secondary-hover) 70%, transparent 100%);
    animation: shimmer 1s ease-in-out infinite;
    content: "";
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
